import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
export default {
    methods: {

        // 获取单条
        GetById(Id) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                Id: Id
            };
            this.loading = true;
            $http.get("api/NetWorkCheck/GetById", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.OrderData = Data

                    if (this.OrderData.ClassInfo) {

                        this.ClassInfo = this.OrderData.ClassInfo
                    } else {
                        this.ClassInfo.ClassId = 0
                    }
                    if (this.OrderData.OrderFrom == 1) {
                        this.BabyInfo = this.OrderData.BabyInfo
                    }

                    this.ParentInfo = this.OrderData.ParentInfo
                    if (this.OrderData.AgentInfo) {
                        this.AgentInfo = this.OrderData.AgentInfo

                    }
                    if (this.OrderData.SchoolInfo) {
                        this.SchoolInfo = this.OrderData.SchoolInfo

                    }
                    if (this.OrderData.NetInfo !== null) {
                        this.NetInfo = this.OrderData.NetInfo
                    }

                    this.SalesInfo = this.OrderData.SalesInfo
                    if (this.OrderData.OrderFrom == 1) {
                        this.GetNetWorkCheckDetailList(this.ClassInfo.ClassId, this.BabyInfo.Id)
                    } else {
                        this.GetNetWorkCheckDetailList(this.ClassInfo.ClassId)
                    }

                    // 发货信息拼接
                    this.ReceiveInfo = []
                    let len = this.OrderData.ReceiveInfo.length
                    for (let i = 0; i < len; i++) {
                        this.ReceiveInfo.push({
                            ProName: this.OrderData.ReceiveInfo[i].ProList[0].ProName,
                            LogisticsName: this.OrderData.ReceiveInfo[i].LogisticsName,
                            LogisticsCode: this.OrderData.ReceiveInfo[i].LogisticsCode,
                            StockOutTime: this.OrderData.ReceiveInfo[i].StockOutTime
                        })
                    }
                });
            });
        },
        // GET /api/NetWorkCheck/GetNetWorkCheckDetailList
        GetNetWorkCheckDetailList(ClassId, BabyId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                ClassId: ClassId,
                BabyId: BabyId,
            };
            this.loading = true;
            $http.get("api/NetWorkCheck/GetNetWorkCheckDetailList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.FollowInfo = Data
                    this.totalSize = Cnt;
                });
            });
        },

    }
}


// WEBPACK FOOTER //
// ./src/pages/Network/networkCheck/components/networkModalDialog/services.js